import type { ComboboxOption } from "@/components/Combobox/types";
import {
  type DivisionDto,
  DivisionSelect,
} from "@/components/Select/DivisionSelect";
import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Props = CFormItemProps & {
  value?: string;
  /** 初期表示の値 */
  displayValue?: string;
  onChange: (option?: ComboboxOption) => void;
  queryKey: string;
  fetchOptions?: () => Promise<DivisionDto>;
  hideSearch?: boolean;
  disabled?: boolean;
};

/**
 * Card-based Form / DivisionSelectItem
 */
export const CFormDivisionSelectItem = buildCFormItem((props: Props) => {
  return (
    <CFormItemBase
      {...props}
      readComponent={props.displayValue}
      writeComponent={
        <DivisionSelect
          value={props.value}
          displayValue={props.displayValue}
          onChange={(option) => props.onChange(option)}
          queryKey={props.queryKey}
          fetchOptions={props.fetchOptions}
          hideSearch={props.hideSearch}
          disabled={props.disabled}
          allowEmpty={!props.required}
        />
      }
    />
  );
});
